import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

import type { TrackingData } from '../types/tracking'

const dynamicEventsWhitelist = new Set(['click_call_expert_component'])

export function useTrackingEvent() {
  const { trackEvent } = useTracking<TrackingData<string>>()
  return useCallback(
    (event: string) => {
      if (dynamicEventsWhitelist.has(event)) {
        trackEvent({
          event: event
        })
      }
    },
    [trackEvent]
  )
}
